import Funds from './Funds';
import FundsForm from './components/Form';

export default Funds;
export { FundsForm };
